import cn from 'classnames/bind';
import NavigationItemLink from 'ui/layouts/MainNavigation/NavigationItemLink';

import s from './MobileNavigationItems.module.scss';

const cx = cn.bind(s);

const MobileNavigationItems = ({
  className, items, ...attrs
}) => (
  <nav className={cx('mobileNav', className)} {...attrs}>
    <ul>
      {items.map((item) => (
        <li key={item.href} className={cx('navItem')}>
          <NavigationItemLink href={item.href} >
            { item.label }
          </NavigationItemLink>
        </li>
      ))}
    </ul>
  </nav>
);

export default MobileNavigationItems;
